module.exports = __webpack_public_path__ + "static/media/20_portrait.1824a37f.jpg";